import { Component, computed, input, output } from '@angular/core';

import { CLAIM_PAGE } from 'src/app/infrastructure/injection-tokens/PAGE-NAME';
import { IImageListData } from 'src/app/features/image/models/image-list-data';
import { ImageTablistComponent } from 'src/app/features/image/components/image-tablist/image-tablist.component';
import { claimPage } from 'src/app/infrastructure/models/claim-page';
import { ITabOwnerClaim } from 'src/app/features/shared/central-page/models/tab-data-template';
import { photoName } from 'src/app/infrastructure/models/image-type';

// Per-type schil om de generieke ImageTablistComponent (zie DomainUserPhotoTablistComponent voor het
// patroon): de eigen foto's van de ingelogde User (FileTypeEnum.UserPhoto) op de Home-pagina.
// ownMainPhotoToggle zonder asProfilePhoto zet User.PhotoFileBoxId — de globale hoofdfoto die als
// fallback geldt wanneer een DomainUser geen domain-specifieke profielfoto heeft gekozen (zie
// UserPhotoPickerComponent). Geen shareToggle/ownerClaim: UserPhotos kennen geen delen-concept en
// de UserPhotos-pagina is al voor elke ingelogde gebruiker geclaimd (geen EntityOwner-bypass nodig).
@Component({
    selector: 'app-user-photo-tablist',
    standalone: true,
    imports: [
        ImageTablistComponent
    ],
    providers: [
        { provide: CLAIM_PAGE, useValue: claimPage.userPhotos },
    ],
    template: `
        <app-image-tablist
            [photoType]="_photoType"
            [claimPagePhoto]="_claimPagePhoto"
            [ownMainPhotoToggle]="true"
            [ownerClaim]="ownerClaim$$()"
            (onPageLoaded)="onPageLoaded.emit()"
            (ownMainPhotoChanged)="onOwnMainPhotoChanged.emit($event)" />
    `,
})
export class UserPhotoTablistComponent {
    onPageLoaded = output<void>();
    // Home is de enige plek waar deze eigen-hoofdfoto (User.PhotoFileBoxId) ook de getoonde
    // hoofdfoto-box is; geeft de wijziging door zodat HomeComponent zijn optimistische override kan
    // zetten (zelfde patroon als ProjectComponent.emit_mainPhotoDrop).
    onOwnMainPhotoChanged = output<IImageListData | null>();

    // Eigen account (EntityOwner) — zelfde owner-bypass als UserProfilePhotoTablistComponent, voor de
    // generieke BtnMainPhotoEdit_Show-check (ImageTablistComponent.canOwnMainPhoto$$).
    ownerGuid = input<string | null>(null);
    ownerClaim$$ = computed<ITabOwnerClaim>(() => ({ kind: 'entity', ownerGuid: this.ownerGuid() }));

    protected readonly _photoType = photoName.userPhoto;
    protected readonly _claimPagePhoto = claimPage.userPhotos;
}
